import { createAnimations } from "@tamagui/animations-css";

import { springs, toCssTransition } from "./springs";

export const animations = createAnimations({
  press: toCssTransition(springs.press),
  enter: toCssTransition(springs.enter),
  exit: toCssTransition(springs.exit),
  expand: toCssTransition(springs.expand),
  overlay: toCssTransition(springs.overlay),
  fade: toCssTransition(springs.fade),
  expressive: toCssTransition(springs.expressive),
  "100ms": "linear 100ms",
  "100ms easeOut": "ease-out 100ms",
  "150ms easeOut": "ease-out 150ms",
  "150ms easeInOut": "cubic-bezier(0.55, 0, 0.25, 1) 150ms",
  "150ms easeIn": "ease-in 150ms",
  "200ms": "linear 200ms",
  "200ms easeOut": "cubic-bezier(0.33, 1, 0.68, 1) 200ms",
  "500ms easeOut": "cubic-bezier(0.33, 1, 0.68, 1) 500ms",
  "200ms easeCubic": "cubic-bezier(0.4, 0, 0.2, 1) 200ms",
  "300ms": "ease-in 300ms",
  "300ms ease": "ease-in-out 300ms",
  bouncy: "cubic-bezier(0.34, 1.56, 0.64, 1) 400ms",
  bouncyMedium: "cubic-bezier(0.34, 1.4, 0.64, 1) 350ms",
  bouncyTight: "cubic-bezier(0.34, 1.3, 0.64, 1) 250ms",
  lazy: "ease-in-out 600ms",
  quick: "cubic-bezier(0.34, 1.2, 0.64, 1) 200ms",
  medium: "cubic-bezier(0.34, 1.1, 0.64, 1) 300ms",
  tooltip: "cubic-bezier(0.34, 1.56, 0.64, 1) 400ms",
});
